// removed by extract-text-webpack-plugin
module.exports = {"board":"board_3xJWL","title":"title_3bjR4","board-button":"board-button_L9L-Z"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/manage/style.css
 ** module id = 328
 ** module chunks = 0
 **/